<template>
  <div id="lineChart">
    <apexchart type="line" height="300" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  name: 'LineChart',
  props: {
    series:{
      type:Array,
      default:()=>{[{
        name: "Positivos",
        data: [0]
      },{
        name: "Negativos",
        data: [0]
      },{
        name: "Neutros",
        data: [0]
      }]}
    },
    categories:{
      type:Array,
      default:()=>{['0']}
    },
    title:{
      type:String,
      default:"Cantidad de Tweets"
    }
  },
  data(){
    return {

      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar:{
            show:false
          }
        },
        colors: ['#00E396','#FF4560','#FEB019'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: this.categories,
          type: 'category',
          title:{
            text: "Fecha",
          },
        },
        yaxis: {
          title:{
            text: this.title,
          },
        },
        tooltip:{
          x: {
            show: false,
          },
        }
      }
    }
  }
}
</script>

<style>

</style>
